import { IPersonalDiagnosticLearningGroup } from 'api/types';
import AcademicYearTitle from 'components/pdfStudent/AcademicYearTitle';
import { useAppSelector } from 'hooks';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';

import PersonalDiagnosticList from './PersonalDiagnosticList';

type PersonalDiagnosticsComponentProps = {
  personalDiagnostics: IPersonalDiagnosticLearningGroup[];
};

const PersonalDiagnosticsComponent = ({ personalDiagnostics }: PersonalDiagnosticsComponentProps) => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const sortedDiagnosticSubjects = personalDiagnostics
    ?.filter((diagnostic) => academicYears.includes(diagnostic.learningYear))
    ?.sort((firstItem, secondItem) => secondItem.learningYear.localeCompare(firstItem.learningYear));

  return (
    sortedDiagnosticSubjects &&
    sortedDiagnosticSubjects?.length !== 0 && (
      <>
        {sortedDiagnosticSubjects.map((diagnostic) => (
          <div key={diagnostic.learningYear}>
            <AcademicYearTitle academicYear={diagnostic.learningYear} />
            <PersonalDiagnosticList diagnostics={diagnostic.diagnostics} />
          </div>
        ))}
      </>
    )
  );
};

export default PersonalDiagnosticsComponent;
